<app-layout [type]="layoutType" size="100%">
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('breadcrumb.invite' | translate) }
]"></app-breadcrumb>
  <div class="invite-container">
    <div class="form-section">
      <app-title title="invite.title" />
      <p class="hint" data-testid="invite-intro">{{ 'invite.intro' | translate }}</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" data-testid="invite-form">
        <app-input [label]="'invite.password' | translate" [formGroup]="form" name="newPassword" type="password"
          [required]="true" (input)="checkPassword()"></app-input>

        <app-input [label]="'invite.confirmPassword' | translate" [formGroup]="form" name="confirmPassword"
          type="password" [required]="true"></app-input>

        @if (passwordMismatch) {
        <div class="error" data-testid="invite-password-mismatch">{{ 'invite.passwordMismatch' | translate }}</div>
        }

        @if (errorKey) {
        <div class="error" data-testid="invite-error">{{ errorKey | translate }}</div>
        }

        <div class="button-group">
          @if (submitting) {
          <app-spinner></app-spinner>
          } @else {
          <app-button variant="primary">
            <button type="submit" data-testid="invite-submit" [disabled]="!canSubmit">{{ 'invite.submit' | translate }}</button>
          </app-button>
          }
        </div>
      </form>
    </div>

    <div class="requirements-section">
      <app-password-requirements [validations]="validations" />
    </div>
  </div>
</app-layout>
